export default "__VITE_ASSET__CTPgYPAp__"